module.exports = __webpack_public_path__ + "static/img/afil.71adf8c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promo/afil.jpeg
// module id = arj4
// module chunks = 9